<script setup>
import { nextTick, onMounted } from "vue";
import useSupplies from "./hooks/useSuppliesTable";
import categoryAdjust from "./categoryAdjust.vue";
import manageAdjust from "./manageAdjust.vue";
import { importMateriel, importmaterialCategory } from "@/api/materiel";
const {
  searchData,
  searchRef,
  columns,
  tableData,
  tableLoading,
  pageParams,
  brandList,
  modelList,
  typeTree,
  categoryRef,
  materielRef,
  treeLoading,
  treeRef,
  getList,
  handleSizeChange,
  handleCurrentChange,
  handleReset,
  getDictList,
  getTypeTree,
  handleCategoryAdjust,
  handleCategoryDelete,
  handleNodeClick,
  filterText,
  filterNode,
  handleMaterielAdjust,
  handleDelete,
  handleUpload,
  uploadRef,
  uploadConfig,
  typeUploadRef,
  handleTypeUpload,
  typeUploadConfig,
} = useSupplies();

const defaultProps = {
  label: "node",
  disabled: function (data, node) {
    if (data.parentId == "0") {
      return true;
    }
  },
};

const categoryChange = () => {
  getList();
  getTypeTree();
};

onMounted(() => {
  getDictList();
  getList();
  getTypeTree();
});
</script>

<template>
  <div class="supplies">
    <zh-table-page v-bind="{ title: '物料管理' }">
      <template #header-btn
        ><el-button
          type="primary"
          icon="Plus"
          @click="handleMaterielAdjust(null, true, typeTree)"
          >新增</el-button
        ></template
      >
      <template #search>
        <el-form :model="searchData" ref="searchRef">
          <el-row :gutter="10">
            <el-col :span="4"
              ><el-form-item prop="name">
                <el-input
                  v-model="searchData.name"
                  placeholder="物料名称"
                /> </el-form-item
            ></el-col>
            <el-col :span="4"
              ><el-form-item prop="number">
                <el-input
                  v-model="searchData.number"
                  placeholder="物料编号"
                /> </el-form-item
            ></el-col>
            <el-col :span="4"
              ><el-form-item prop="brand">
                <el-select v-model="searchData.brand" placeholder="物料品牌">
                  <el-option
                    v-for="item in brandList"
                    :key="item.dictValue"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                  />
                </el-select> </el-form-item
            ></el-col>
            <el-col :span="4"
              ><el-form-item prop="model">
                <!-- <el-select v-model="searchData.model" placeholder="物料规格型号">
                <el-option
                  v-for="item in modelList"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                />
              </el-select>  -->
                <el-input
                  v-model="searchData.model"
                  placeholder="物料规格型号"
                />
              </el-form-item>
            </el-col>

            <el-col :span="4"
              ><el-form-item prop="key">
                <el-select v-model="searchData.key" placeholder="重点物料">
                  <el-option label="是" :value="1" />
                  <el-option label="否" :value="0" />
                </el-select> </el-form-item
            ></el-col>
            <el-col :span="8">
              <el-form-item>
                <el-button type="primary" icon="Search" @click="getList()"
                  >查询</el-button
                >
                <el-button icon="Refresh" @click="handleReset()"
                  >重置</el-button
                >
                <el-button icon="Upload" @click="handleUpload()"
                  >导入</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>
      <template #left>
        <div style="width: 290px; padding-right: 10px">
          <div class="tree-title">
            物料类别编制弹窗
            <div class>
              <el-icon style="margin-right: 8px" @click="handleTypeUpload()"
                ><Upload
              /></el-icon>
              <el-icon @click.stop="handleCategoryAdjust({}, { id: 0 }, true)">
                <CirclePlusFilled color="#409EFF" />
              </el-icon>
            </div>
          </div>

          <el-input
            v-model="filterText"
            style="width: calc(100% - 10px); margin-bottom: 10px"
            placeholder="请输入名称搜索"
          />
          <el-tree
            ref="treeRef"
            :data="typeTree"
            node-key="id"
            default-expand-all
            :props="defaultProps"
            :expand-on-click-node="false"
            :highlight-current="true"
            @node-click="handleNodeClick"
            :current-node-key="typeTree[0]?.id"
            :filter-node-method="filterNode"
          >
            <template #default="{ node, data }">
              <span class="custom-tree-node">
                <span>{{ node.label + "(" + data.totalCount + ")" }}</span>
                <span class="btn">
                  <el-icon @click.stop="handleCategoryAdjust(node, data, true)">
                    <CirclePlusFilled color="#409EFF" />
                  </el-icon>
                  <el-icon
                    @click.stop="handleCategoryAdjust(node, data, false)"
                    v-if="!data.children"
                  >
                    <EditPen color="#67C23A" />
                  </el-icon>
                  <el-icon
                    @click.stop="handleCategoryDelete(data)"
                    v-if="!data.children"
                  >
                    <DeleteFilled color="#F56C6C" />
                  </el-icon>
                </span>
              </span>
            </template>
          </el-tree>
        </div>
      </template>
      <template #table>
        <el-table
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{
            'text-align': 'center',
          }"
          style="width: 100%"
          max-height="630"
          :data="tableData"
          v-loading="tableLoading"
        >
          <template v-for="item in columns" :key="item.prop">
            <el-table-column
              :label="item.label"
              :prop="item.prop"
              :show-overflow-tooltip="item.showOverflowTooltip"
              :fixed="item.fixed || false"
              :width="item.width"
            >
              <template #default="{ row }">
                <span v-if="item.prop === 'key'">{{
                  row[item.prop] === 1 ? "是" : "否"
                }}</span>
                <span v-else>{{ row[item.prop] || "-" }}</span>
              </template>
            </el-table-column>
          </template>
          <el-table-column label="操作" width="150" fixed="right">
            <template #default="{ row }">
              <el-button
                type="primary"
                link
                @click="handleMaterielAdjust(row, false, typeTree)"
                >编辑</el-button
              >
              <el-button type="danger" link @click="handleDelete(row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="mt10"
          background
          style="margin-top: 10px"
          :current-page="pageParams.page"
          :page-size="pageParams.size"
          :page-sizes="[10, 20, 30, 50]"
          :total="pageParams.total"
          layout="->, total, prev, pager, next, sizes, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </template>
    </zh-table-page>
    <!-- 物料类别编制弹窗 -->
    <category-adjust ref="categoryRef" @after-save="categoryChange" />

    <!-- 物料管理编制弹窗 -->
    <manage-adjust ref="materielRef" @after-save="getList" />

    <!-- 导入组件 -->
    <FileUpload
      ref="uploadRef"
      @afterUpload="getList"
      :fn="importMateriel"
      :uploadConfig="uploadConfig"
    />
    <!-- 导入物料类别组件 -->
    <FileUpload
      ref="typeUploadRef"
      @afterUpload="categoryChange"
      :fn="importmaterialCategory"
      :uploadConfig="typeUploadConfig"
    />
  </div>
</template>

<style scoped lang="less">
.supplies {
  height: 100%;
  width: 100%;
}
.tree-title {
  font-size: 16px;
  height: 20px;
  line-height: 20px;
  padding: 8px 0 10px 8px;
  display: flex;
  justify-content: space-between;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.btn {
  width: 60px;
  display: flex;
  justify-content: space-between;
}
</style>
<style>
.supplies .tablePage-container-left {
  height: calc(100% - 10px) !important;
}
</style>
